import { useSelector } from "react-redux";
import {
  getAppraisalData,
  getQuestionsAndAnswers
} from "../../../store/selectors";
import { useDispatch } from "react-redux";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import { sortAnswers } from "../../helpers";
import { useState } from "react";
import { getAnswerFromQuestionById } from "../../../helpers/appraisals";
import { replacePlaceholderValues } from "../../../helpers/replacePlaceholderValues";
import { TooltipReplaceableValues } from "../../../data/QuestionData";

interface useRadioAndToolTipQuestionProps {
  question: Question;
  replaceManufacturerName?: boolean;
}

function useRadioAndToolTipQuestion({
  question,
  replaceManufacturerName = false
}: useRadioAndToolTipQuestionProps) {
  const dispatch = useDispatch();
  const {
    questionValidation,
    vehicle: { manufacturer }
  } = useSelector(getAppraisalData);
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const storedAnswerTooltip =
    getAnswerFromQuestionById(question, storedAnswer)?.tooltip || "";
  const [answerTooltip, setAnswerTooltip] = useState(storedAnswerTooltip);
  const [selectedOption, setSelectedOption] = useState(storedAnswer);

  const toolTipToDisplay = replaceManufacturerName
    ? replacePlaceholderValues(
        answerTooltip,
        TooltipReplaceableValues.MANUFACTURER,
        manufacturer
      )
    : answerTooltip;

  const handleAnswerChange = (answerId: number) => {
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    if (questionValidation) {
      dispatch(appraisalSlice.actions.setQuestionValidation(""));
    }
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({
        [question.id]: [answerId]
      })
    );
  };

  const sortedAnswers = sortAnswers(question.answers);

  return {
    answerTooltip: toolTipToDisplay,
    error: questionValidation,
    handleChange: handleAnswerChange,
    selectedOption,
    setAnswerTooltip,
    setSelectedOption,
    sortedAnswers,
    storedAnswer
  };
}

export default useRadioAndToolTipQuestion;
